<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import 'print-js'
export default {
	name: 'App',
	created () {
		window.$router = this.$router
		this.$store.dispatch('account/getAccenum')
	}
}
</script>

<style>
.BMap_cpyCtrl,
.anchorBL {
  display: none;
}
</style>
